import { TableContainer as ChakraTableContainer } from "@chakra-ui/react";

export const TableContainer = ChakraTableContainer;
